module.exports = __webpack_public_path__ + "idea-management-2-340c7a538b034eba75e0be038c6d735e.webp";